import { render, staticRenderFns } from "./ActivityPrice.vue?vue&type=template&id=47fd2c8b&scoped=true"
import script from "./ActivityPrice.vue?vue&type=script&lang=js"
export * from "./ActivityPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fd2c8b",
  null
  
)

export default component.exports